import { NgClass } from '@angular/common';
import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { NavigationEnd, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { filter } from 'rxjs';
import { SvgIconComponent } from '../icons/svg-icon/svg-icon.component';
interface DropdownItem {
  label: string;
  route: string;
}

@Component({
    selector: 'app-dropdown',
        standalone: true,
imports: [NgClass, MatIcon, SvgIconComponent, TranslatePipe],
    templateUrl: './dropdown.component.html',
    styleUrl: './dropdown.component.scss'
})
export class DropdownComponent {
  @Input() title: string = '';
  @Input() size: string = '';
  @Input() icon: string = '';
  @Input() colorTheme: string = '';
  @Input() items: DropdownItem[] = [];

  isOpen: boolean = false;
  isActive: boolean = false;
  constructor(private router: Router, private elementRef: ElementRef) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkActive();
      });
  }

  ngOnInit(): void {
    this.checkActive();
  }

  toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }

  navigateTo(route: string): void {
    this.router.navigate([route]);
    this.isOpen = false;
  }
  checkActive(): void {
    const currentUrl = this.router.url;
    this.isActive = this.items.some(
      (item) => currentUrl.startsWith(item.route) || currentUrl === item.route
    );

    // Auto-open dropdown if a child route is active (optional)
    // if (this.isActive) {
    //   this.isOpen = true;
    // }
  }

  // Check if specific item is active
  isItemActive(route: string): boolean {
    return this.router.url.startsWith(route) || this.router.url === route;
  }
  @HostListener('document:click', ['$event'])
  clickOutside(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }
}
